import { combineEpics, ofType } from 'redux-observable'
import { EMPTY, of } from 'rxjs'
import { catchError, filter, map, switchMap, takeUntil } from 'rxjs/operators'

import { getTimezoneId } from 'utils/dateUtils'
import { isSimulationAndTraining } from 'utils/plans'
import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import {
  selectActualLicenses,
  selectHasSelectedCompanyFilterAccess,
} from 'containers/App/selectors'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'

import { DATE_FILTER_CHANGE, SCANBACK_CHANGE } from '../constants'
import {
  selectDateRange,
  selectHasIncidentWidgetAccess,
  selectIncidentsWidgetsVisibility,
} from '../selectors'

import { resolvedIncidentWidgetRedux } from './redux'

const getResolvedIncidentsWidgetEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      resolvedIncidentWidgetRedux.INITIATE,
      DATE_FILTER_CHANGE,
      SCANBACK_CHANGE
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    }),
    switchMap(() => {
      const state = state$.value
      // INITIATE and company-data success turn the loader on. Cancel so a child
      // the user cannot swap into does not leave the widget spinning.
      if (!selectHasSelectedCompanyFilterAccess(state)) {
        return of(resolvedIncidentWidgetRedux.cancel())
      }
      const licenses = selectActualLicenses(state)
      const isWidgetVisible = selectIncidentsWidgetsVisibility(state)
      const hasWidgetAccess = selectHasIncidentWidgetAccess(state)

      if (isSimulationAndTraining(licenses.plan) || !isWidgetVisible || !hasWidgetAccess) {
        return EMPTY
      }

      const selectedCompany = selectCompanyFilter(state)

      const feDateRange = selectDateRange(state)

      const baseParams = {
        feDateRange,
        timezone: getTimezoneId(),
      }

      return api.dashboard.getResolvedIncidentsWidget(selectedCompany?.value, baseParams).pipe(
        map((response) => resolvedIncidentWidgetRedux.onSuccess(response.response)),
        catchError((error) => of(epicsErrorHandler(resolvedIncidentWidgetRedux.onError, error))),
        takeUntil(
          action$.pipe(
            ofType(resolvedIncidentWidgetRedux.CANCEL, resolvedIncidentWidgetRedux.ERROR)
          )
        )
      )
    })
  )

export default combineEpics(getResolvedIncidentsWidgetEpic)
